module.exports = {
    NEW_PROJECT_CLASS: '#new-diagram-button',
    TEMPLATE_PROJECT_CLASS: '#template-diagram-button',
    OPEN_PROJECT_CLASS: '#open-diagram-button',
    SAVE_PROJECT_CLASS: '#save-diagram-button',
    PROJECT_SETTINGS_CLASS: '#settings-button',

    LAYOUT_MANUAL: '#manualLayoutButton',
    LAYOUT_TREE: '#treeAutoLayoutButton',
    LAYOUT_CLUSTER: '#clusterAutoLayoutButton',

    EXPORT_TO_PNG: '#saveButton',
    EXPORT_TO_SVG: '#saveButtonSvg',
    EXPORT_TO_PDF: '#saveButtonPdf',

    UNDO: '#undoButton',
    REDO: '#redoButton',
    HELP: '#help-button',

    // HORIZONTAL_MARGIN: '#margin-horizontal',
    // VERTICAL_MARGIN: '#margin-vertical',
    MAX_EDGE: '#edge-slant-width-max',
    WIDTH_SIZE: '#grid-width',
    HEIGHT_SIZE: '#grid-height',

    VARIABLES: '#sd-sidebar-definitions-open-dialog-button',
    SENSITIVITY: '#sensitivity-analysis-button',
    RECALCULATE: '#sd-definitions-dialog-recalculate-button',
};



// WEBPACK FOOTER //
// ./scripts/components/constants/silver-decisions.js